import { Dispatch } from 'redux';
import AdAudienceController from '../controllers/AdAudienceController';
import adAudiencesHandler from '../errorHandlers/ad-audience-handler';
import commonHandler from '../errorHandlers/common-handler';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from './CrudActionContainer';

class AdAudienceCRUDActions extends CrudActionContainer {
  resetAction: string;

  assignAdAudience(facebookPageId: number, audienceId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        return await AdAudienceController.assignAdAudience(
          facebookPageId,
          audienceId,
        );
      } catch (e) {
        return adAudiencesHandler(dispatch, this)(e);
      }
    };
  }

  retrieve(facebookPageId: number, audienceId: number, remoteId: string) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        return await AdAudienceController.getAudience(
          facebookPageId,
          audienceId,
          remoteId,
        );
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  constructor() {
    super('AD_AUDIENCES');
  }
}

const adAudienceCRUDActions = new AdAudienceCRUDActions();

export default adAudienceCRUDActions;
